<template lang="pug">
v-layout.pa-4(align-center justify-center)
  v-flex.flex-col( class='text-xs-center')
    v-form(:disabled="isLoading")
      v-text-field(
        v-model='username'
        light
        prepend-icon='email'
        label='Ingresa tu usuario (email)'
        ref="username"
        type='email',
        @keyup.enter="fetchLogin()"

      )
      v-text-field(
        hide-details
        prepend-icon='lock'
        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
        ref="password"
        :type="showPassword ? 'text' : 'password'"
        label='Ingresa tu contraseña'
        v-model='password'
        @click:append='showPassword = !showPassword',
        @keyup.enter="fetchLogin()"
      )
      v-checkbox( v-model='shouldStayLoggedIn' light label='Permanecer conectado')
      v-btn( block color="primary", @click="fetchLogin()", :loading="isLoading") Ingresar
    .d-flex.jc-center.ai-center.mt-4
      span.font-size-12 ¿Olvidaste tu contraseña?
      v-btn.ml-1( small, text color="primary" @click="goTo('/forgot-password-request')") click aquí
</template>

<script>
import Router from '../router/not_logged.js'
import { notify } from '../util/general'
export default {
  name: 'login',
  data () {
    return {
      // username    : 'aris.sorporte.sistemas@gmail.com',
      // password    : '123456a+',
      username          : '',
      password          : '',
      isLoading         : false,
      showPassword      : false,
      shouldStayLoggedIn: true
    }
  },
  methods: {
    lowercase (e) {
      var vm = this
      vm.username = e.target.value.toLowerCase();
    },
    fetchLogin () {
      var vm          = this
      if (!vm.username) {
        notify(vm, 'error', 'Error', 'Ingrese un usuario valido')
        vm.$refs.username.focus()
        return
      }

      if (!vm.password) {
        notify(vm, 'error', 'Error', 'Ingrese un password valido')
        vm.$refs.password.focus()
        return
      }

      vm.isLoading = true
      var obj = {
        empresa: process.env.EMPRESA,
        username: vm.username,
        password: vm.password
      }

      vm.axios.post('/usuario/login', obj).then((response) => {
        var data = response.data
        if (data.status) {
          localStorage.setItem('perfil', data.perfil)
          localStorage.setItem('username', data.username)
          localStorage.setItem('codigoCliente', data.codigoCliente)
          localStorage.setItem('nombre', data.nombre)
          localStorage.setItem('razonSocial', data.razonSocial)
          localStorage.setItem('entidad', data.entidad)
          localStorage.setItem('token', data.token)
          localStorage.setItem('tokenSistServer', data.tokenSistServer)
          localStorage.setItem('tokenOctopus', data.tokenOctopus)
          localStorage.setItem('esCuentaAdministrador', data.esCuentaAdministrador)
          localStorage.setItem('ruc', data.ruc)
          window.location.reload(true)
          vm.isLoading = false
        } else {
          notify(vm, 'error', 'Error', data.message)
          vm.isLoading = false
        }
      }).catch((error) => {
        notify(vm, 'error', 'Error', error.message)
        vm.isLoading = false
      })
    },
    goTo (page) {
      Router.push(page)
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>



// WEBPACK FOOTER //
// Login_View.vue?7da579b6